import { cn } from '@/utils/styleUtils'
import Button from '@a24/ui/Button'
import Icon from '@a24/ui/Icon'
import Popover from '@a24/ui/Popover'
import Title from '@a24/ui/Title'
import type { RefObject } from 'react'

interface IProps {
  ref: RefObject<HTMLDivElement | null>
  onClick: () => void
}
const ConfirmationPopover = ({ ref, onClick }: IProps) => {
  return (
    <Popover
      popover='manual'
      className={cn(
        'top-[50%] translate-y-[-50%]  px-12 md:px-28 py-12 md:py-20',
        'border w-[90vw] md:w-auto border-heritage-black-full',
        'backdrop:bg-heritage-black-full/20 rounded bg-heritage-white-full',
        'left-[50%] translate-x-[-50%]'
      )}
      ref={ref}
      buttonProps={{ className: 'hidden' }}
    >
      <div className='relative text-center md:max-w-96 mx-auto'>
        <Title
          level='h2'
          text='Are you sure you want to continue?'
          className='heading-md'
        />
        <div className='flex  flex-wrap justify-center gap-4 mt-10'>
          <Button onClick={onClick} className='w-full button-primary'>
            Continue Booking{' '}
            <Icon name='arrow-right' width={8} height={8} className='ml-2' />
          </Button>
        </div>
      </div>
    </Popover>
  )
}

export default ConfirmationPopover
